import { useState } from 'react';
import { Nav } from 'react-bootstrap';
import LeadsPanel from './LeadsPanel';
import DemoRequestsPanel from './DemoRequestsPanel';

// leads_business_flow_requirement.md — one page for the whole onboarding pipeline: the leads the
// admin is working themselves (LeadsPanel) and the inbound "Request a Demo" queue
// (DemoRequestsPanel), as two tabs instead of two separate dashboard entries. Every demo request
// that names this vertical also auto-appears as a lead (routes/platformAdmin.js), so this is
// genuinely one place to see everything, not just a shared URL.

export default function OnboardingPanel() {
  const [tab, setTab] = useState('leads');
  return (
    <div>
      <Nav variant="pills" activeKey={tab} onSelect={(k) => setTab(k || 'leads')} className="mb-3">
        <Nav.Item><Nav.Link eventKey="leads">Leads</Nav.Link></Nav.Item>
        <Nav.Item><Nav.Link eventKey="demo-requests">Demo requests</Nav.Link></Nav.Item>
      </Nav>
      {tab === 'leads' ? <LeadsPanel /> : <DemoRequestsPanel />}
    </div>
  );
}
